import styled from 'styled-components';
import {COLORS} from '../../../shared/consts';

export const DevicesCardsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: 768px) {
    gap: 24px;
  }
`;

export const IntroText = styled.p`
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${COLORS.FG.SOFT};
  max-width: 650px;
  white-space: pre-line;

  @media (max-width: 768px) {
    font-size: 14px;
    margin-bottom: 32px;
  }
`;
